import { combineReducers } from "redux";
import query from './reducers/query';
import search from './reducers/search';
import selectList from './reducers/select_list';
import tasks from './reducers/tasks';
import ui from './reducers/ui';

const nullReducer = state => ({ ...state });

export default combineReducers({
  query,
  search,
  paths: nullReducer,
  selectList,
  static: nullReducer,
  tasks,
  ui
});
